import React from 'react';

import {formatPattern, WithRouterProps} from 'react-router';

interface Props extends Pick<WithRouterProps, 'routes' | 'params'> {
  breadcrumbProps?: Record<string, unknown>;
}

export const SPBreadcrumbs = React.memo<Props>(
  ({routes, params, breadcrumbProps = {}}: Props) => {
    const routesWithBreadcrumbs = routes.filter(
      (r) => r.props?.breadcrumb != null
    );

    return (
      <nav aria-label="breadcrumb" className="text-truncate">
        <ol className="breadcrumb flex-nowrap mb-0 pl-0">
          {routesWithBreadcrumbs.map((route, index) => {
            const link = formatPattern(
              routes
                .slice(0, routes.indexOf(route) + 1)
                .map((route) => route.path || '')
                .map((path) => (path.indexOf('/') === 0 ? path : `/${path}`))
                .join('')
                .replace(/\/\/+/g, '/'),
              params
            );
            const BreadcrumbComponent: React.ComponentType<any> =
              route.props.breadcrumb;

            return (
              <BreadcrumbComponent
                link={link}
                key={index}
                active={index === routesWithBreadcrumbs.length - 1}
                {...breadcrumbProps}
              />
            );
          })}
        </ol>
      </nav>
    );
  }
);
